<p-confirmDialog [style]="{width: '50vw'}" acceptLabel="Current Page" rejectLabel="All Pages"
                 [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
                 acceptIcon="pi pi-download"
                 [rejectIcon]="isFileDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                 [baseZIndex]="10000" acceptButtonStyleClass="p-button-secondary"
                 rejectButtonStyleClass="p-button-secondary"></p-confirmDialog>
<p-toast position="top-right" key="user-mgmt-message"></p-toast>
<p-menu #userMenu [model]="userOptionMenu" [popup]="true"></p-menu>
<!--Update password-->
<p-dialog [(visible)]="displayUpdateUserPassword" [blockScroll]="true" [modal]="true" class="update-user-dialog"
          [showHeader]="true"
          [closable]="true"
          [header]="'Update Password for : ' + selectedUser?.username"
          [closeOnEscape]="true"
          [draggable]="false"
          [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
          [style]="{width: '35%'}">

    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-field">
                <small>
                    Password *
                </small>
                <p-password [toggleMask]="true" [(ngModel)]="updatedPassword" class="password-input"
                            styleClass="width-100"
                ></p-password>
            </div>
        </div>

        <div class="p-col-12">
            <div class="p-field">
                <small>
                    Confirm Password *
                </small>
                <p-password [toggleMask]="true" [(ngModel)]="updatedConfirmPassword"
                            [ngModelOptions]="{standalone: true}"
                            class="password-input"
                            styleClass="width-100"></p-password>
            </div>
        </div>

        <div class="p-col-6 p-text-left">
            <button (click)="onCancelOfUpdatePassword()" pButton pRipple class="p-button-danger p-button-sm"
                    label="Cancel"></button>
        </div>
        <div class="p-col-6 p-text-right">
            <button (click)="updateUserPassword()" pButton pRipple class="p-button-secondary p-button-sm"
                    label="Update"></button>
        </div>

    </div>

</p-dialog>

<!--Update User Basic Details-->
<p-dialog [(visible)]="displayUpdateUserDetails" [blockScroll]="true" [modal]="true" class="update-user-dialog"
          [showHeader]="true"
          [closable]="true"
          [header]="'Update Basic Details for : ' + selectedUser?.username"
          [closeOnEscape]="true"
          [draggable]="false"
          [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
          [style]="{width: '35%'}">

    <div>
        <div class="p-grid" [formGroup]="userBasicDetailsForm">
            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        First Name *
                    </small>
                    <input type="email" formControlName="firstName" pInputText class="width-100">
                </div>
            </div>
            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        Last Name *
                    </small>
                    <input type="email" formControlName="lastName" pInputText class="width-100">
                </div>
            </div>
            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        Email *
                    </small>
                    <input type="email" formControlName="email" pInputText class="width-100">
                </div>
            </div>

            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        Roles *
                    </small>
                    <p-multiSelect styleClass="width-100"
                                   appendTo="body"
                                   [options]="roles"
                                   formControlName="roles"
                                   emptyMessage="No Roles Found"
                                   filterBy="name"
                                   emptyFilterMessage="No Roles Found"
                                   optionLabel="name"
                    ></p-multiSelect>
                </div>
            </div>


            <div class="p-col-6 p-text-left">
                <button (click)="onCancelOfUpdateUserBasicDetails()" pButton pRipple class="p-button-danger p-button-sm"
                        label="Cancel"></button>
            </div>
            <div class="p-col-6 p-text-right">
                <button (click)="updateUserBasicDetails()" pButton pRipple class="p-button-secondary p-button-sm"
                        label="Update"></button>
            </div>

        </div>
    </div>

</p-dialog>
<div class="p-mt-3">
    <p-breadcrumb [home]="home" [model]="breadcrumbMenuModel"></p-breadcrumb>

    <!--Search User-->

    <div class="p-grid p-mt-3 p-jc-between p-mr-3 p-ai-center">
        <div class="p-col-12 p-md-6 p-lg-4">
                 <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               (change)="handleUserSearch($event)"
                               pInputText class="width-100"/>
                        <label>Search User</label>
						<i class="pi pi-search"></i>
					</span>
        </div>
        <div class="p-col-12 p-md-6 p-lg-4 p-text-right">
            <img (click)="downloadFiles()" pRipple class="fp-icon-height p-cursor"
                 src="assets/branding/shared-icons/export-excel.svg" alt="excel-export">
        </div>
    </div>

    <div class="card p-mt-3 p-shadow-4">

        <!--User Header-->

        <div class="p-grid p-ai-center divider-bottom">
            <div class="p-col-6">
                <h5 class="p-text-primary p-m-0"> Users </h5>
            </div>

            <div class="p-col-6 p-text-right">
                <button (click)="navigateToNewUserCreation()" pButton pRipple [icon]="'pi pi-user-plus'"
                        class="p-button-icon p-button-secondary"></button>
            </div>
        </div>

        <!--Loader/Spinner-->

        <div *ngIf="isLoading" class="p-d-flex p-ai-center p-jc-center" style="min-height: 400px">
            <div class="p-text-center">
                <div>
                    <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 2rem"></i>
                </div>
                <div class="p-mt-3 p-text-secondary p-text-bold">
                    Loading Users !
                </div>
            </div>
        </div>

        <!--If No User is Found from DB-->

        <div *ngIf="filteredUsers?.content?.length === 0 && !isLoading"
             class="p-d-flex p-ai-center p-jc-center" style="min-height: 400px">
            <div class="p-text-center p-mt-3 p-text-secondary p-text-bold">
                No Users Found!
            </div>
        </div>


        <!--User Listing-->

        <div *ngIf="filteredUsers?.content?.length > 0 && !isLoading">

            <p-table class="user-data-table" [value]="filteredUsers?.content">
                <ng-template pTemplate="header">
                    <tr class="p-text-left width-100">
                        <th pSortableColumn="username" class="p-py-3">
                            <div class="p-d-flex p-ai-center width-100">
                                <div>
                                    Username
                                </div>
                                <div class="p-ml-2">
                                    <p-sortIcon field="username"></p-sortIcon>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div pSortableColumn="firstName" class="p-d-flex p-ai-center width-100">
                                <div>
                                    First Name
                                </div>
                                <div class="p-ml-2">
                                    <p-sortIcon field="firstName"></p-sortIcon>
                                </div>
                            </div>
                        </th>
                        <th pSortableColumn="lastName">
                            <div class="p-d-flex p-ai-center width-100">
                                <div>
                                    Last Name
                                </div>
                                <div class="p-ml-2">
                                    <p-sortIcon field="lastName"></p-sortIcon>
                                </div>
                            </div>
                        </th>
                        <th pSortableColumn="lastName">
                            <div class="p-d-flex p-ai-center width-100">
                                <div>
                                    User Domains
                                </div>
                                <div class="p-ml-2">
                                    <p-sortIcon field="lastName"></p-sortIcon>
                                </div>
                            </div>
                        </th>
                        <th pSortableColumn="lastName">
                            <div class="p-d-flex p-ai-center width-100">
                                <div>
                                    User Customers
                                </div>
                                <div class="p-ml-2">
                                    <p-sortIcon field="lastName"></p-sortIcon>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div>
                                Account Status
                            </div>
                        </th>
                        <th style="width: 30px;">
                        </th>

                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-user>
                    <tr class="p-text-left width-100 divider-bottom">
                        <td class="p-py-3">
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                {{user?.username ? user?.username : '-'}}
                            </div>
                        </td>
                        <td>
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                {{user?.firstName ? user?.firstName : '-'}}
                            </div>
                        </td>
                        <td>
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                {{user?.lastName ? user?.lastName : '-'}}
                            </div>
                        </td>

                        <td>
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                <div *ngIf="user?.userDomains?.length === 0 || !user?.userDomains || user?.userDomains?.length === 17">
                                    All Domains Assigned
                                </div>
                                <div *ngIf="user?.userDomains?.length > 0 && user?.userDomains?.length < 17">
                                    <div *ngFor="let domain of user?.userDomains">
                                        <div class="p-mt-2">
                                            {{domain?.domainName}} <span class="fp-text-bold">({{domain?.domainId}}
                                            ) </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>

                        <td>
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                <div *ngIf="user?.userEntities?.length === 0 || !user?.userEntities || user?.userEntities?.length === 17">
                                    -
                                </div>
                                <div *ngFor="let entity of user?.userEntities">
                                    <div class="p-mt-2">
                                        {{entity?.name}} <span class="fp-text-bold">({{entity?.businessEntityId}}
                                        ) </span>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                <!--                                [checkboxIcon]="'pi pi-times'"-->
                                <div class="p-d-flex p-ai-center">
                                    <div>
                                        <p-checkbox (onChange)="handleBlockOrInBlockUser(user)"
                                                    [(ngModel)]="user.enabled"
                                                    name="enabled" [binary]="true"></p-checkbox>
                                    </div>
                                    <div class="p-ml-2" [class]="user.enabled ? 'p-text-success' : 'p-text-danger'">
                                        {{user.enabled ? 'Active' : 'Not Active'}}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td style="width: 30px;">
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                <i class="pi pi-ellipsis-v p-text-primary p-text-bold p-cursor"
                                   (click)="handleUserOptionMenu($event, user)"
                                   style="font-size: 1.5rem;"></i>
                            </div>
                        </td>

                    </tr>
                </ng-template>
            </p-table>

        </div>

        <!--User Listing Pagination-->

        <div class="p-mt-2">
            <p-paginator #userPagination
                         (onPageChange)="paginateFilteredUsers($event)" [rows]="10"
                         [totalRecords]="filteredUsers?.totalElements"></p-paginator>
        </div>

    </div>
</div>
